const EVENT_NAMES = {
	ONBOARDING_FORM_VISIT: "onboarding_form_visit",
	ONBOARDING_FORM_SUBMITTED: "onboarding_form_submitted",
	KYC_INITIATED: "kyc_initiated",
	KYC_COMPLETED: "kyc_completed",
	KYC_FAILED: "kyc_failed",
	RECHARGE_PAYMENT_INITIATED: "recharge_payment_initiated",
	RECHARGE_PAYMENT_DONE: "recharge_payment_done",
	RECHARGE_PAYMENT_FAILED: "recharge_payment_failed",
	SHIPPING_RATE_CALCULATOR_VISIT: "shipping_rate_calculator_visit",
	ADD_ORDER_CLICKED: "add_order_clicked",
	ORDER_PAYMENT_MODE_SELECTED: "order_payment_mode_selected",
	ORDER_ADDED_SUCCESS: "order_added_success",
	SHIP_NOW_INITIATED: "ship_now_initiated",
	BANNERS_CLICKED: "banners_clicked",
	RECHARGE_POPUP_VIEWED: "recharge_popup_viewed",
	RECHARGE_COUPON_ENTERED: "recharge_coupon_entered",
	RECHARGE_COUPON_FAILED: "recharge_coupon_failed",
	DASHBOARD_PAGE_VISIT: "dashboard_page_visit",
	SHIP_NOW_SUCCESS: "ship_now_success",
	LOW_BALANCE_NUDGED: "low_balance_nudged",
	SIDE_NAVIGATION_CLICKED: "side_navigation_clicked",
	BUTTON_CLICKED: "button_clicked",
	CARGO_ONBOARDING_TOUR_V1: "cargo_onboarding_tour_v1",
	CARGO_ONBOARDING_TOUR_V2: "cargo_onboarding_tour_v2",
	KYC: "kyc",
	RECHARGE_WALLET: "recharge_wallet",
	BOOK_SHIPMENT: "book_shipment",
	RATE_CALCULATOR: "rate_calculator",
	HOME_PAGE: "home_page",
	ORDER_PAGE: "order_page",
	SUPPORT_PAGE: "support_page",
	SETTING_PAGE: "setting_page",
	ONBOARDING_SCREEN_VIEW: "onboarding_screen_view",
	ONBOARDING_CTA_CLICKED: "onboarding_cta_clicked",
	ONBOARDING_USER_TYPE_SELECTED: "onboarding_user_type_selected",
	ONBOARDING_FIELD_FILLED: "onboarding_field_filled",
	ONBOARDING_TC_ACCEPTED: "onboarding_tc_accepted",
	ONBOARDING_COMPLETED: "onboarding_completed",
	ONBOARDING_BUSINESS_TYPE_SELECTED: "onboarding_business_type_selected",
	ONBOARDING_PRODUCT_CATEGORY_SELECTED: "onboarding_product_category_selected",
	CANCEL_CLICKED: "cancel_clicked",
	CANCEL_DECISION: "cancel_decision",

	// onboarding page events

	LOGIN_VIEW: "login_view",
	LOGIN_ERROR: "login_error",
	LOGIN_DONE: "login_done",
	PERSONA_INFO: "persona_info",
	PERSONA_INFO_SWITCH: "persona_info_switch",
	RECHARGE_WALLET_VIEWED: "recharge_wallet_viewed",
	RECHARGE_DONE: "recharge_done",
	RATE_API_FAILED: "rate_api_failed",

	// Help & Support page events

	SUPPORT_PAGE_VIEWED: "support_page_viewed",
	SUPPORT_SEARCH_USED: "support_search_used",
	SUPPORT_FILTER_INTERACTED: "support_filter_interacted",
	SUPPORT_TICKET_HISTORY_TOGGLED: "support_ticket_history_toggled",
	SUPPORT_CREATE_TICKET_OPENED: "support_create_ticket_opened",
	SUPPORT_CREATE_TICKET_INPUT: "support_create_ticket_input",
	SUPPORT_CANCEL_SHIPMENT: "support_cancel_shipment",
	SUPPORT_TICKET_CREATED: "support_ticket_created",
	SUPPORT_TICKET_EDIT_CLICKED: "support_ticket_edit_clicked",
	SUPPORT_TICKET_UPDATED: "support_ticket_updated",

	// NDR page events

	NDR_PAGE_VIEWED: "ndr_page_viewed",
	NDR_FILTER_INTERACTED: "ndr_filter_interacted",
	AWB_CLICKED: "awb_clicked",
	LABEL_URL_CLICKED: "label_url_clicked",
	POD_URL_CLICKED: "pod_url_clicked",
	SHIP_CHARGE_HISTORY_CLICKED: "ship_charge_history_clicked",
	REATTEMPT_CLICKED: "reattempt_clicked",
	REATTEMPT_DECISION: "reattempt_decision",
	BOOK_APPOINTMENT_CLICKED: "book_appointment_clicked",
	BOOK_APPOINTMENT_DECISION: "book_appointment_decision",

	// tootls page events

	SRCALC_PAGE_VIEWED: "srcalc_page_viewed",
	SRCALC_CALCULATE: "srcalc_calculate",
	SERVICE_PAGE_VIEWED: "service_page_viewed",
	SERVICE_CHECK: "service_check",
	SERVICE_DOWNLOAD_LIST: "service_download_list",
	SERVICE_DOWNLOAD_PROCEED: "service_download_proceed",
	PINCODE_PAGE_VIEWED: "pincode_page_viewed",
	PINCODE_ZONE_DOWNLOAD: "pincode_zone_download",
	RATE_CHART_PAGE_VIEWED: "rate_chart_page_viewed",
	RATE_CHART_MODE: "rate_chart_mode",

	// Billing page events

	INVOICES_PAGE_VIEWED: "invoices_page_viewed",
	INVOICES_VIEWED: "invoices_viewed",
	INVOICES_DOWNLOAD_POD: "invoices_download_pod",
	BILLING_DOWNLOAD_WAYBILL: "billing_download_waybill",
	INVOICES_PAY_NOW: "invoices_pay_now",
	REMITTANCE_PAGE_VIEWED: "remittance_page_viewed",
	PASSBOOK_PAGE_VIEWED: "passbook_page_viewed",
	CREDIT_NOTES_PAGE_VIEWED: "credit_notes_page_viewed",
	CREDIT_NOTES_VIEWED: "credit_notes_viewed",
	PAYMENTS: "payments",
	LOCATION_PAGE_VIEWED: "location_page_viewed",

	// Shipment events
	DP_SELECTED: "dp_selected",

	// pickup scheduled  events

	RESCHEDULE_PICKUP_INITIATED: "reschedule_pickup_initiated",
	RESCHEDULE_PICKUP_COMPLETED: "reschedule_pickup_completed",
	PICKUP_DATES_SELECTION_POPUP: "pickup_date_selection_popup",

	// ECOD Events

	ECOD_PAGE_VIEWED: "ecod_page_viewed",
	ECOD_PLAN_ACTIVATE_INITIATE: "ecod_plan_activate_initiate",
	ECOD_PLAN_ACTIVATE_COMPLETE: "ecod_plan_activate_complete",
	ECOD_PLAN_DEACTIVATE: "ecod_plan_deactivate",
	REMITTANCE_FILTER_INTERACTED: "remittance_filter_interacted",
	REMITTANCE_DOC_UPLOADED: "remittance_doc_uploaded",
	REMITTANCE_CRF_DOWNLOADED: "remittance_crf_downloaded",
	REMITTANCE_TAB_SWITCH: "remittance_tab_switch",
	REMITTANCE_FILE_DOWNLOAD: "remittance_file_download",

	// Home Page Events

	KYC_INITIATED_EV2: "kyc_initiated_ev2",
	RECHARGE_POPUP_VIEWED_EV2: "recharge_popup_viewed_ev2",
	ADD_ORDER_CLICKED_EV2: "add_order_clicked_ev2",
	SRCALC_ADVANCE: "srcalc_advance",
	SRCALC_SHORT: "srcalc_short",
	REQUEST_CALL: "request_call",
	SCHEDULE_TRAINING: "schedule_training",
	VIEW_VIDEO: "view_video",
	BANNER_CLICKED: "banner_clicked",

	// cancel reschedule pickup page events

	CANCEL_RESCHEDULE_PICKUP_INITIATED: "cancel_reschedule_pickup_initiated",
	CANCEL_RESCHEDULE_PICKUP_COMPLETED: "cancel_reschedule_pickup_completed",

	// Shipment listings v2 events

	CANCEL_CLICKED_V2: "cancel_clicked_v2",
	CANCEL_DECISION_CLOSED_V2: "cancel_decision_closed_v2",
	CANCEL_DECISION_CANCELLED_V2: "cancel_decision_cancelled_v2",
	RESCHEDULE_PICKUP_INITIATED_V2: "reschedule_pickup_initiated_v2",
	RESCHEDULE_PICKUP_COMPLETE_V2: "reschedule_pickup_complete_v2",
	APPOINTMENT_SCHEDULE_INITIATED_V2: "appointment_schedule_initiated_v2",
	APPOINTMENT_SCHEDULE_DONE_V2: "appointment_schedule_done_v2",
	APPOINTMENT_SCHEDULE_ERROR_V2: "appointment_schedule_error_v2",
	CANCEL_RESCHEDULE_PICKUP_INITIATED_V2:
		"cancel_reschedule_pickup_initiated_v2",
	CANCEL_RESCHEDULE_PICKUP_COMPLETE_V2: "cancel_reschedule_pickup_complete_v2",
	ALL_SHIPMENTS_CLICKED_V2: "all_shipments_clicked_v2",
	NEW_TAB_CLICKED_V2: "new_tab_clicked_v2",
	READY_TO_SHIP_TAB_CLICKED_V2: "ready_to_ship_tab_clicked_v2",
	IN_TRANSIT_TAB_CLICKED_V2: "in_transit_tab_clicked_v2",
	DELIVERED_TAB_CLICKED_V2: "delivered_tab_clicked_v2",
	RTO_TAB_CLICKED_V2: "rto_tab_clicked_v2",
	CANCEL_REQUESTS_TAB_CLICKED_V2: "cancel_requests_tab_clicked_v2",
	ALL_TAB_CLICKED_V2: "all_tab_clicked_v2",
	EDIT_ORDER_CLICKED_V2: "edit_order_clicked_v2",
	CLONE_ORDER_CLICKED_V2: "clone_order_clicked_v2",
	CANCEL_ORDER_CLICKED_V2: "cancel_order_clicked_v2",
	SHIP_NOW_CLICKED_V2: "ship_now_clicked_v2",
	GET_SUPPORT_CLICKED_V2: "get_support_clicked_v2",
	CLONE_SHIPMENT_CLICKED_V2: "clone_shipment_clicked_v2",
	DOWNLOAD_LABEL_CLICKED_V2: "download_label_clicked_v2",
	UPDATE_EWAYBILL_CLICKED_V2: "update_ewaybill_clicked_v2",
	TRACK_SHIPMENT_CLICKED_V2: "track_shipment_clicked_v2",
	TAKE_ACTION_CLICKED_V2: "take_action_clicked_v2",
	DOWNLOAD_POD_CLICKED_V2: "download_pod_clicked_v2",
	ORDER_ID_HPL_CLICKED_V2: "order_id_hpl_clicked_v2",
	WAYBILL_HPL_CLICKED_V2: "waybill_hpl_clicked_v2",
	ADD_BULK_SHIPMENT_CLICKED_V2: "add_bulk_shipment_clicked_v2",
	ADD_SINGLE_SHIPMENT_CLICKED_V2: "add_single shipment_clicked_v2",
	BULK_UPLOAD_EWAYBILL_CLICKED_V2: "bulk_upload_ewaybill_clicked_v2",
	DOWNLOAD_MIS_V2: "download_mis_v2",
	HOME_PAGE_VISIT: "home_page_visit",
	RECHARGE_POPUP_CTA_CLICKED: "recharge_popup_cta_clicked",
	TRACKING_AWB_SEARCH: "tracking_awbsearch",
	SWITCH_TO_MBROWSER_CLICK: "switch_to_mbrowser_click",
	ABD_EMAIL_CLICK: "abd_email_click",
	ABD_APPOINTMENT_SUBMITTED: "abd_appointment_submitted",

	// CargoMBrowser mweb GA4 spec events

	SCREEN_VIEW: "screen_view",
	TAB_SWITCH: "tab_switch",
	HOME_VIEW: "home_view",
	QUICK_ACTION_TAP: "quick_action_tap",
	RECENT_SEARCH_TAP: "recent_search_tap",
	WALLET_BALANCE_VIEW: "wallet_balance_view",
	KYC_BANNER_VIEW: "kyc_banner_view",
	COURIER_SHEET_VIEW: "courier_sheet_view",
	COURIER_MODE_TOGGLE: "courier_mode_toggle",
	COURIER_SELECTED: "courier_selected",
	ADDRESS_STEP_VIEW: "address_step_view",
	PINCODE_ENTERED: "pincode_entered",
	PINCODE_SERVICEABILITY: "pincode_serviceability",
	ADDRESS_SAVED: "address_saved",
	AI_FILL_BANNER_VIEW: "ai_fill_banner_view",
	AI_FILL_BANNER_TAP: "ai_fill_banner_tap",
	AI_FILL_FILE_ACCEPTED: "ai_fill_file_accepted",
	AI_FILL_FILE_REJECTED: "ai_fill_file_rejected",
	AI_FILL_SUBMITTED: "ai_fill_submitted",
	AI_FILL_EXTRACT_SUCCESS: "ai_fill_extract_success",
	AI_FILL_EXTRACT_FAILED: "ai_fill_extract_failed",
	AI_FILL_ABANDONED: "ai_fill_abandoned",
	AI_FILL_APPLIED: "ai_fill_applied",
	PACKAGE_ADDED: "package_added",
	PACKAGE_DETAILS_SAVED: "package_details_saved",
	EWAY_REQUIRED_FLAGGED: "eway_required_flagged",
	PICKUP_SHEET_VIEW: "pickup_sheet_view",
	PICKUP_SLOT_SELECTED: "pickup_slot_selected",
	PAYMENT_STEP_VIEW: "payment_step_view",
	ADD_PAYMENT_INFO: "add_payment_info",
	WALLET_INSUFFICIENT: "wallet_insufficient",
	RECHARGE_AMOUNT_SELECTED: "recharge_amount_selected",
	CONFIRMATION_VIEW: "confirmation_view",
	KYC_PENDING_CARD_VIEW: "kyc_pending_card_view",
	LABEL_DOWNLOAD_LOCKED_VIEW: "label_download_locked_view",
	LABEL_DOWNLOAD_TAP: "label_download_tap",
	EWAY_GATE_VIEW: "eway_gate_view",
	EWAY_BILL_ENTERED: "eway_bill_entered",
	EWAY_BILL_SUBMITTED: "eway_bill_submitted",
	BACK_TO_HOME_TAP: "back_to_home_tap",
	ORDERS_VIEW: "orders_view",
	ORDER_SEARCH: "order_search",
	ORDER_FILTER_APPLIED: "order_filter_applied",
	ORDER_CARD_TAP: "order_card_tap",
	MORE_VIEW: "more_view",
	MORE_ACTION_TAP: "more_action_tap",
	DRAFT_SAVED: "draft_saved",
	DRAFT_RESUMED: "draft_resumed",
	ERROR_SHOWN: "error_shown",
	CHECK_RATES_AGAIN_TAP: "check_rates_again_tap",

	// Appointment Delivery v2 spec events
	// (/client/appointmentdelivery-v2 and /client/appointment-details/:orderId)

	APPOINTMENT_PAGE_VIEW: "appointment_page_view",
	APPOINTMENT_TAB_CLICKED: "appointment_tab_clicked",
	APPOINTMENT_FILTER_APPLIED: "appointment_filter_applied",
	APPOINTMENT_SEARCH: "appointment_search",
	APPOINTMENT_ROW_CLICKED: "appointment_row_clicked",
	ADD_APPOINTMENT_CLICKED: "add_appointment_clicked",
	TRACK_SHIPMENT_CLICKED: "track_shipment_clicked",
	UPDATE_APPOINTMENT_CLICKED: "update_appointment_clicked",
	DOWNLOAD_POD_CLICKED: "download_pod_clicked",
	APPOINTMENT_ACTIVITY_TAB: "appointment_activity_tab",
	TRACKING_TAB: "tracking_tab",
	APPOINTMENT_CREATED: "appointment_created",
	APPOINTMENT_UPDATED: "appointment_updated",
	PO_DOWNLOADED: "po_downloaded",
	VALIDATION_ERROR: "validation_error",
	API_FAILURE: "api_failure",
};

/**
 * Value for the `client_type` property attached to every CargoMBrowser (mweb)
 * event — see src/pages/CargoMBrowser/components/cargo/hooks/useCargoAnalytics.ts.
 * Derived from shipment_count: 0 means the client has never shipped before.
 */
export const CLIENT_TYPE = {
	NEW: "New Client",
	EXISTING: "Existing Client",
};

export default EVENT_NAMES;
